import { Component, OnInit, Input } from '@angular/core';
import { formatNumber } from '../../../utils/common';

@Component({
  selector: 'icc-total-mo-sms',
  templateUrl: './icc-total-mo-sms.component.html',
  styleUrls: ['./icc-total-mo-sms.component.less'],
})
export class IccTotalMoSmsComponent implements OnInit {
  constructor() {}

  @Input() data: {
    count: 'number';
    users: 'number';
    unsubscribe: 'number';
    keywords: 'number';
    others: 'number';
  };

  viewData: {
    count: 'string';
    users: 'string';
    unsubscribe: 'string';
    keywords: 'string';
    others: 'string';
  };

  ngOnInit() {
    const viewData: any = {
      count: 0,
      users: 0,
      unsubscribe: 0,
      keywords: 0,
      others: 0,
    };
    if (this.data) {
      for (const key in this.data) {
        if (this.data.hasOwnProperty(key)) {
          const number = this.data[key];
          viewData[key] = formatNumber(number);
        }
      }
    }
    this.viewData = viewData;
  }
}
